import revive_payload_client_4sVQNw7RlN from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/atlantic/atlantic/agents/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/atlantic/atlantic/agents/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_5j40ijIZYu from "/home/runner/work/atlantic/atlantic/agents/node_modules/@nuxtjs/plausible/dist/runtime/plugin.client.js";
import vapor_pIQavGOz06 from "/home/runner/work/atlantic/atlantic/agents/modules/support/vapor/runtime/plugins/vapor.ts";
import stripe_client_zGdfFdiFbE from "/home/runner/work/atlantic/atlantic/agents/modules/support/stripe/runtime/plugins/stripe.client.ts";
import plugin_Fgx7Ax6uz0 from "/home/runner/work/atlantic/atlantic/agents/modules/support/echo/runtime/plugin.ts";
import plugin_Rz8rTBCrlc from "/home/runner/work/atlantic/atlantic/agents/modules/support/nuxt-sanctum-auth/runtime/plugin.ts";
import pwa_client_Eorgdr12jA from "/home/runner/work/atlantic/atlantic/agents/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import plugin_8SbxDRbG6Y from "/home/runner/work/atlantic/atlantic/agents/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/atlantic/atlantic/agents/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/home/runner/work/atlantic/atlantic/agents/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import fontawesome_cn2c4tOOHz from "/home/runner/work/atlantic/atlantic/agents/plugins/fontawesome.ts";
import growthbook_Iy8w9k9ghu from "/home/runner/work/atlantic/atlantic/agents/plugins/growthbook.ts";
import middleware_2wzLuOatkW from "/home/runner/work/atlantic/atlantic/agents/plugins/middleware.ts";
import modaler_zty5jgybqw from "/home/runner/work/atlantic/atlantic/agents/plugins/modaler.ts";
import pageTransition_lo8TYkQBOw from "/home/runner/work/atlantic/atlantic/agents/plugins/pageTransition.ts";
import pinia_48xmdi2HHl from "/home/runner/work/atlantic/atlantic/agents/plugins/pinia.ts";
import pwa_update_client_etP3CbLkyW from "/home/runner/work/atlantic/atlantic/agents/plugins/pwa-update.client.ts";
import ray_yW6CJrBkXG from "/home/runner/work/atlantic/atlantic/agents/plugins/ray.ts";
import sentry_client_shVUlIjFLk from "/home/runner/work/atlantic/atlantic/agents/plugins/sentry.client.ts";
import userguiding_client_ikW9no8lEl from "/home/runner/work/atlantic/atlantic/agents/plugins/userguiding.client.ts";
import vueDatePicker_GfeYHwmpe2 from "/home/runner/work/atlantic/atlantic/agents/plugins/vueDatePicker.ts";
import vueGoogleMaps_8xmoAwKZvr from "/home/runner/work/atlantic/atlantic/agents/plugins/vueGoogleMaps.ts";
import ziggy_SNjz8uXtjk from "/home/runner/work/atlantic/atlantic/agents/plugins/ziggy.ts";
import plugin_auto_pageviews_client_x3Y8XIaaPY from "/home/runner/work/atlantic/atlantic/agents/node_modules/@nuxtjs/plausible/dist/runtime/plugin-auto-pageviews.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_5j40ijIZYu,
  vapor_pIQavGOz06,
  stripe_client_zGdfFdiFbE,
  plugin_Fgx7Ax6uz0,
  plugin_Rz8rTBCrlc,
  pwa_client_Eorgdr12jA,
  plugin_8SbxDRbG6Y,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  fontawesome_cn2c4tOOHz,
  growthbook_Iy8w9k9ghu,
  middleware_2wzLuOatkW,
  modaler_zty5jgybqw,
  pageTransition_lo8TYkQBOw,
  pinia_48xmdi2HHl,
  pwa_update_client_etP3CbLkyW,
  ray_yW6CJrBkXG,
  sentry_client_shVUlIjFLk,
  userguiding_client_ikW9no8lEl,
  vueDatePicker_GfeYHwmpe2,
  vueGoogleMaps_8xmoAwKZvr,
  ziggy_SNjz8uXtjk,
  plugin_auto_pageviews_client_x3Y8XIaaPY
]